import Image from 'next/image';
import React from 'react';

const Logo = ({ src, height, width }) => (
	<div id='pca__sidebar-logo'>
		<Image id='pca__logo-image' alt='App Logo' height={height} src={src} width={width} data-cy='sidebar-logo' />
	</div>
);

export default Logo;
